import type {BillFiltersInput, PageRequestTypeInput} from '../../../graphql/types/settlement';

export type SettlementBillListTab = 'client' | 'dsp' | 'delivery-dsp' | 'wms-dsp';

export interface SettlementBillListPersistedState {
    filters: BillFiltersInput;
    tempFilters: BillFiltersInput;
    pageRequest: PageRequestTypeInput;
    billIdInput: string;
    selectedTimeZone?: string;
}

const STATE_KEY_PREFIX = 'settlement-bill-list-state-';
const RESTORE_FLAG_PREFIX = 'settlement-bill-list-restore-';

function stateKey(tab: SettlementBillListTab): string {
    return `${STATE_KEY_PREFIX}${tab}`;
}

function restoreFlagKey(tab: SettlementBillListTab): string {
    return `${RESTORE_FLAG_PREFIX}${tab}`;
}

export function saveSettlementBillListState(
    tab: SettlementBillListTab,
    state: SettlementBillListPersistedState
): void {
    sessionStorage.setItem(stateKey(tab), JSON.stringify(state));
}

export function markSettlementBillListRestore(tab: SettlementBillListTab): void {
    sessionStorage.setItem(restoreFlagKey(tab), '1');
}

export function consumeSettlementBillListState(
    tab: SettlementBillListTab
): SettlementBillListPersistedState | null {
    if (sessionStorage.getItem(restoreFlagKey(tab)) !== '1') {
        return null;
    }
    // 注意：不要在 render/初始化阶段立即清除 restoreFlag。
    // React Strict Mode 可能导致组件在开发环境下重复初始化，
    // 立即 remove 会让第二次初始化拿不到 state，表现为“返回详情后筛选条件丢失”。
    // 延迟到下一事件循环清除，保证同一轮渲染/初始化内可重复读取。
    setTimeout(() => {
        sessionStorage.removeItem(restoreFlagKey(tab));
    }, 0);
    const raw = sessionStorage.getItem(stateKey(tab));
    if (!raw) {
        return null;
    }
    try {
        return JSON.parse(raw) as SettlementBillListPersistedState;
    } catch {
        return null;
    }
}

export function persistBeforeBillDetailNavigation(
    tab: SettlementBillListTab,
    state: SettlementBillListPersistedState
): void {
    saveSettlementBillListState(tab, state);
    markSettlementBillListRestore(tab);
}
